import styled, { css } from 'styled-components';

export const Place = styled.div`
  position: absolute;
  top: ${(props) => props.$topPos ?? '45px'};
  z-index: 10;
  box-shadow: 0px 8px 28px rgba(0, 0, 0, 0.45);
  background: #161e23;
  border: 1px solid #2c353d;
  color: #e6eaec;
  padding: 15px;
  max-width: 100%;
  min-width: ${(props) => props.$minWidth ?? '280px'};
  border-radius: 12px;
  &:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #161e23;
    top: -10px;
    left: ${(props) => props.$arrowPos ?? '50px'};
  }
  ${(props) =>
    props.$above &&
    css`
      bottom: 45px;
      top: auto;
      &:before {
        top: auto;
        bottom: -10px;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #161e23;
        border-bottom: 0;
      }
    `}
`;

export const Content = styled.div``;

export const SimpleModalButtons = styled.div`
  background-color: #12171c;
  border-top: 1px solid #2c353d;
  margin: 15px -15px -15px;
  border-radius: 0 0 12px 12px;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  button {
    min-width: 60px;
  }
`;

export const SimpleModalTitle = styled.div`
  font-size: 18px;
  line-height: normal;
  margin: 0 0 15px;
  text-align: center;
  color: #e6eaec;
`;
